import React from "react";
import SmoothScroll from "../components/SmoothScroll";
import Nav from "../components/Nav";
import Hero from "../components/Hero";
import Essence from "../components/Essence";
import Spaces from "../components/Spaces";
import Accompaniment from "../components/Accompaniment";
import Testimonials from "../components/Testimonials";
import Pricing from "../components/Pricing";
import Close from "../components/Close";
import Footer from "../components/Footer";
import WhatsAppFloat from "../components/WhatsAppFloat";

export default function Landing() {
    return (
        <SmoothScroll>
            <div className="min-h-screen bg-alma-white text-alma-ink font-sans antialiased overflow-x-hidden">
                <Nav />
                <main>
                    <Hero />
                    <Essence />
                    <Spaces />
                    <Accompaniment />
                    <Testimonials />
                    <Pricing />
                    <Close />
                </main>
                <Footer />
                <WhatsAppFloat />
            </div>
        </SmoothScroll>
    );
}
